import { ReactSVG } from "react-svg";
import NewToolTip from "../../../../common/New-ToolTip";
import AirTreatment from "../../../../common/tooltip/minor-ailments/air-treatment";
import SmokeTreatment from "../../../../common/tooltip/minor-ailments/smoke-treatment";
import { pharmacologicalCards } from "./pharmacological/data";

export const frequencyAndDurationEnum = {
  header: "Frequency and Duration of Symptoms",
  question: "How long and how often have you been having these symptoms?",
  subquestion: null,
  options: [
    {
      value: "lessThanFourWeeks",
      header:
        "Symptoms up to 4 days per week OR \nfor less than 4 weeks at a time (consecutive)",
      subHeader: null,
    },
    {
      value: "moreThanFourWeeks",
      header:
        "Symptoms on 4 or more days AND \nfor more than 4 weeks at a time (consecutive)",
      subHeader: null,
    },
  ],
};

export const levelOfSeverityEnum = {
  header: "Level of Severity & Effect",
  question: "Do symptoms affect daily activities?",
  subquestion: null,
  options: [
    {
      value: "symptomsDoNotInterfereWithActivities",
      header: "Symptoms DO NOT interfere with daily activities",
      subHeader: "(work, school, sport , leisure). Normal sleep.",
    },
    {
      value: "symptomsInterfereWithActivities",
      header: "Symptoms interfere with daily activities",
      subHeader: "(work, school, sport , leisure). Disturbs sleep.",
    },
  ],
};

export const classificationResultCalculation = (
  frequencyOfSymptoms,
  levelOfSeverity
) => {
  if (
    frequencyOfSymptoms === "lessThanFourWeeks" &&
    levelOfSeverity === "symptomsDoNotInterfereWithActivities"
  ) {
    return "Mild Intermittent";
  } else if (
    frequencyOfSymptoms === "lessThanFourWeeks" &&
    levelOfSeverity === "symptomsInterfereWithActivities"
  ) {
    return "Moderate to Severe Intermittent";
  } else if (
    frequencyOfSymptoms === "moreThanFourWeeks" &&
    levelOfSeverity === "symptomsDoNotInterfereWithActivities"
  ) {
    return "Mild Persistent";
  } else if (
    frequencyOfSymptoms === "moreThanFourWeeks" &&
    levelOfSeverity === "symptomsInterfereWithActivities"
  ) {
    return "Moderate to Severe Persistent";
  }
};

export const GetPharmacologicalCards = (
  showAddOnTherapy = false,
  clasificationResult
) => {
  const filters = {
    "Mild Intermittent": [
      "firstLineOralAntihistamines",
      "stepUpIntranasalCorticosteroids",
      "alternativeFirstLineCombination",
    ],
    "Mild Persistent": ["firstLineIntranasalCorticosteroids"],
    "Moderate to Severe Intermittent": [
      "firstLineIntranasalCorticosteroids",
      "stepUpCombination",
    ],
    "Moderate to Severe Persistent": [
      "firstLineIntranasalCorticosteroids",
      "stepUpCombination",
    ],
  };

  const addOnTherapyTypes = {
    "Mild Intermittent": [],
    "Mild Persistent": ["addOnTherapyOralAntihistamines"],
    "Moderate to Severe Intermittent": ["addOnTherapyOralAntihistamines"],
    "Moderate to Severe Persistent": ["addOnTherapyOralAntihistamines"],
  };

  let resultCards = pharmacologicalCards.filter(
    (card) =>
      filters[clasificationResult]?.includes(card.type) ||
      (showAddOnTherapy &&
        addOnTherapyTypes[clasificationResult]?.includes(card.type))
  );

  return resultCards;
};

export const goalsDataMinorAilment = [
  {
    title: "Relief",
    description: "Provide RELIEF from symptoms to an allergic response.",
  },
  {
    title: "Prevent",
    description: "PREVENT symptoms by avoiding exposure to allergens.",
  },
  {
    title: "Minimize",
    description: "MINIMIZE side effects of treatment for allergic rhinitis.",
  },
  {
    title: "Improve",
    description: "IMPROVE quality of life.",
  },
];

export const goalsDataMedicationReview = [
  {
    title: "MANAGE MEDICATIONS",
    description: "Understand the REASONS for taking prescription medications.",
  },
  {
    title: "MANAGE SIDE EFFECTS",
    description: "Prevent and manage side effects.",
  },
  {
    title: "MANAGE CHRONIC CONDITIONS",
    description: "Understand how medications manage chronic conditions.",
  },
  {
    title: "IMPROVE QUALITY OF LIFE",
    description: "Reduce hospital visits and maintain control of chronic conditions.",
  },
];

export const preventionData = [
  {
    mainImage: "/icons/treatment/home-main.svg",
    alterImage: "/icons/treatment/home-alter.svg",
    render: () => {
      return (
        <ul className="list-disc px-[20px] mt-8 text-body-xl font-medium">
          <li className="text-gray-800">
            Use Air Conditioning; keep windows and doors closed{" "}
          </li>
          <li className="text-gray-800">Keep pets out of bedrooms</li>
          <li className="text-gray-800">
            Remove houseplants; a common source of mould
          </li>
        </ul>
      );
    },
  },
  {
    mainImage: "/icons/treatment/leaf-main.svg",
    alterImage: "/icons/treatment/leaf-alter.svg",
    render: () => {
      return (
        <ul className="list-disc px-[20px] mt-8 text-body-xl font-medium">
          <li className="text-gray-800">
            Use hypo-allergenic mattress and pillow covers
          </li>
          <li className="text-gray-800">
            Wash bedding once a week with hot water
          </li>
          <li className="text-gray-800">Do not hang clothes outside to dry</li>
        </ul>
      );
    },
  },
  {
    mainImage: "/icons/treatment/spray-main.svg",
    alterImage: "/icons/treatment/spray-alter.svg",
    render: () => {
      return (
        <ul className="list-disc px-[20px] mt-8 text-body-xl font-medium">
          <li className="text-gray-800">
            Avoid insect sprays, strong scents, and paint
          </li>
          <li className="text-gray-800">
            Spend less time outdoors during periods of high pollen counts
          </li>
        </ul>
      );
    },
  },
  {
    mainImage: "/icons/treatment/air-main.svg",
    alterImage: "/icons/treatment/air-alter.svg",
    render: () => {
      return (
        <ul className="list-disc px-[20px] mt-8 text-body-xl font-medium">
          <li className="text-gray-800">
            Minimize use of humidifiers and cool mist vaporizers. (If using,
            keep them clean)
            <ReactSVG
              src="/icons/information-dark.svg"
              className="w-5 h-5 ml-1  inline-block"
              data-tooltip-id="air-treatment"
            />
            <NewToolTip id="air-treatment" render={() => <AirTreatment />} />
          </li>
          <li className="text-gray-800">Install a HEPA filter</li>
        </ul>
      );
    },
  },
  {
    mainImage: "/icons/treatment/smoke-main.svg",
    alterImage: "/icons/treatment/smoke-alter.svg",
    render: () => {
      return (
        <ul className="list-disc px-[20px] mt-8 text-body-xl font-medium">
          <li className="text-gray-800">
            Avoid tobacco smoke (first and second hand smoke)
          </li>
          <li className="text-gray-800">
            Refer to Smoking Cessation Module for various interventions
            <ReactSVG
              src="/icons/information-dark.svg"
              className="w-5 h-5 ml-1  inline-block"
              data-tooltip-id="smoke-treatment"
            />
            <NewToolTip
              id="smoke-treatment"
              render={() => <SmokeTreatment />}
            />
          </li>
        </ul>
      );
    },
  },
];

export const allergensAndIrritantsEnum = {
  header: "Allergens and Irritants",
  question: "Did you avoid the Allergens and Irritants?",
  subquestion: null,
  options: [
    {
      value: "yes",
      header: "Yes",
      subHeader: null,
    },
    {
      value: "no",
      header: "No",
      subHeader: null,
    },
  ],
  customInput: {
    name: "allergensdAndIrritantsComments",
    type: "textarea",
    label: "",
    placeholder: "Comments (Optional)",
  },
};

export const allergensAndIrritantsEffectiveEnum = {
  header: "Allergens and Irritants",
  question: "Was it effective to avoid the allergens or irritants?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const nasalIrrigationsEnum = {
  header: "Nasal Irrigations, Sprays, or Lubricants",
  question:
    "Did you use Nasal Irrigations, Sprays, or Lubricants? Select all that apply.",
  subquestion: null,
  options: [
    {
      value: "nasalRinses",
      header: "Nasal Rinses",
      subHeader: null,
    },
    {
      value: "nasalSprays",
      header: "Nasal Sprays or Drops ",
      subHeader: null,
    },
    {
      value: "nasalLubricants",
      header: "Nasal Lubricants ",
      subHeader: null,
    },
    {
      value: "none",
      header: "None",
      subHeader: null,
    },
  ],
  customInput: {
    name: "nasalIrrigationsComments",
    type: "textarea",
    label: "",
    placeholder: "Comments (Optional)",
  },
};

export const nasalIrrigationsLengthEnum = {
  header: "Nasal Irrigations, Sprays, or Lubricants",
  question: "How long did you take the medication?",
  subquestion: null,
  options: [
    {
      value: "lessThanTwoWeeks",
      header: "Less than 2 weeks",
      subHeader: null,
    },
    {
      value: "moreThanTwoWeeks",
      header: "More than 2 weeks",
      subHeader: null,
    },
  ],
};

export const nasalIrrigationsEffectiveEnum = {
  header: "Nasal Irrigations, Sprays, or Lubricants",
  question: "Was the medication effective?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const nasalIrrigationsSideEffectsEnum = {
  header: "Nasal Irrigations, Sprays, or Lubricants",
  question: "Did you have any side effects? ",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const nasalOrOralDecongestantsEnum = {
  header: "Nasal or Oral Decongestants",
  question: "Did you use Nasal or Oral Decongestants? Select all that apply.",
  subquestion: null,
  options: [
    {
      value: "oralDecongestants",
      header: "Oral Decongestants",
      subHeader: null,
    },
    {
      value: "nasalDecongestants",
      header: "Nasal Decongestants",
      subHeader: null,
      tooltipComponent: (
        <>
          <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-3 text-left font-normal">
            Not recommended to use for more than 3 to 5 days<br/>due to rebound congestion
          </div>
        </>
      ),
    },
    {
      value: "none",
      header: "None",
      subHeader: null,
    },
  ],
  customInput: {
    name: "nasalOrOralDecongestantsComments",
    type: "textarea",
    label: "",
    placeholder: "Comments (Optional)",
  },
};

export const nasalOrOralDecongestantsLengthEnum = {
  header: "Nasal or Oral Decongestants",
  question: "How long did you take the medication?",
  subquestion: null,
  options: [
    {
      value: "lessThanTwoWeeks",
      header: "Less than 2 weeks",
      subHeader: null,
    },
    {
      value: "moreThanTwoWeeks",
      header: "More than 2 weeks",
      subHeader: null,
    },
  ],
};

export const nasalOrOralDecongestantsEffectiveEnum = {
  header: "Nasal or Oral Decongestants",
  question: "Was the medication effective?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const nasalOrOralDecongestantsProperUseEnum = {
  header: "Nasal or Oral Decongestants",
  question: "Was proper technique used?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const nasalOrOralDecongestantsSideEffectsEnum = {
  header: "Nasal or Oral Decongestants",
  question: "Did you have any side effects? ",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const oralAntihistaminesEnum = {
  header: "Oral Antihistamines",
  question: "Did you use Oral Antihistamines?",
  subquestion: null,
  customInput: {
    name: "oralAntihistaminesComments",
    type: "textarea",
    label: "",
    placeholder: "Comments (Optional)",
  },
  options: [
    {
      value: "yes",
      header: "Yes",
      subHeader: null,
    },
    {
      value: "no",
      header: "No",
      subHeader: null,
    },
    {
      value: "notsure",
      header: "Not Sure",
      subHeader: null,
    },
  ],
};

export const oralAntihistaminesLengthEnum = {
  header: "Oral Antihistamines",
  question: "How long did you take the medication?",
  subquestion: null,
  options: [
    {
      value: "lessThanTwoWeeks",
      header: "Less than 2 weeks",
      subHeader: null,
    },
    {
      value: "moreThanTwoWeeks",
      header: "More than 2 weeks",
      subHeader: null,
    },
  ],
};

export const oralAntihistaminesEffectiveEnum = {
  header: "Oral Antihistamines",
  question: "Was the medication effective?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const oralAntihistaminesSideEffectsEnum = {
  header: "Oral Antihistamines",
  question: "Did you have any side effects?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const intranasalCorticosteroidsEnum = {
  header: "Intranasal Corticosteroids",
  question: "Did you use Intranasal Corticosteroids?",
  subquestion: null,
  customInput: {
    name: "intranasalCorticosteroidsComments",
    type: "textarea",
    label: "",
    placeholder: "Comments (Optional)",
  },
  options: [
    {
      value: "yes",
      header: "Yes",
      subHeader: null,
    },
    {
      value: "no",
      header: "No",
      subHeader: null,
    },
    {
      value: "notsure",
      header: "Not Sure",
      subHeader: null,
    },
  ],
};

export const intranasalCorticosteroidsLengthEnum = {
  header: "Intranasal Corticosteroids",
  question: "How long did you take the medication?",
  subquestion: null,
  options: [
    {
      value: "lessThanTwoWeeks",
      header: "Less than 2 weeks",
      subHeader: null,
    },
    {
      value: "moreThanTwoWeeks",
      header: "More than 2 weeks",
      subHeader: null,
    },
  ],
};

export const intranasalCorticosteroidsEffectiveEnum = {
  header: "Intranasal Corticosteroids",
  question: "Was the medication effective?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const intranasalCorticosteroidsProperUseEnum = {
  header: "Intranasal Corticosteroids",
  question: "Was proper technique used?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const intranasalCorticosteroidsSideEffectsEnum = {
  header: "Intranasal Corticosteroids",
  question: "Did you have any side effects?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const intranasalAntihistaminesAndCorticosteroidsEnum = {
  header: "Intranasal Antihistamine/Corticosteroid",
  question: "Did you use Intranasal Antihistamine/Corticosteroids combination?",
  subquestion: null,
  customInput: {
    name: "intranasalAntihistaminesAndCorticosteroidsComments",
    type: "textarea",
    label: "",
    placeholder: "Comments (Optional)",
  },
  options: [
    {
      value: "yes",
      header: "Yes",
      subHeader: null,
    },
    {
      value: "no",
      header: "No",
      subHeader: null,
    },
    {
      value: "notsure",
      header: "Not Sure",
      subHeader: null,
    },
  ],
};

export const intranasalAntihistaminesAndCorticosteroidsLengthEnum = {
  header: "Intranasal Antihistamine/Corticosteroid",
  question: "How long did you take the medication?",
  subquestion: null,
  options: [
    {
      value: "lessThanTwoWeeks",
      header: "Less than 2 weeks",
      subHeader: null,
    },
    {
      value: "moreThanTwoWeeks",
      header: "More than 2 weeks",
      subHeader: null,
    },
  ],
};

export const intranasalAntihistaminesAndCorticosteroidsEffectiveEnum = {
  header: "Intranasal Antihistamine/Corticosteroid",
  question: "Was the medication effective?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const intranasalAntihistaminesAndCorticosteroidsProperUseEnum = {
  header: "Intranasal Antihistamine/Corticosteroid",
  question: "Was proper technique used?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const intranasalAntihistaminesAndCorticosteroidsSideEffectsEnum = {
  header: "Intranasal Antihistamine/Corticosteroid",
  question: "Did you have any side effects?",
  subquestion: null,
  options: [
    {
      value: true,
      header: "Yes",
      subHeader: null,
    },
    {
      value: false,
      header: "No",
      subHeader: null,
    },
  ],
};

export const haveYouSeenPrimaryPhysicianEnum = {
  question:
    "Have you seen your Primary Provider for Allergic Rhinitis in the past 12 months",
  options: [
    {
      value: "no",
      label: "No",
    },
    {
      value: "lastThreeMonths",
      label: "Yes, within the last 3 Months",
    },
    {
      value: "lastSixMonths",
      label: "Yes, within the last 6 Months",
    },
    {
      value: "lastTwelveMonths",
      label: "Yes, within the last 12 Months",
    },
  ],
};

export const haveYouSeenEmergencyClinicEnum = {
  question:
    "Have you visited an emergency clinic for Allergic Rhinitis in the past 12 months?",
  options: [
    {
      value: "no",
      label: "No",
    },
    {
      value: "lastThreeMonths",
      label: "Yes, within the last 3 Months",
    },
    {
      value: "lastSixMonths",
      label: "Yes, within the last 6 Months",
    },
    {
      value: "lastTwelveMonths",
      label: "Yes, within the last 12 Months",
    },
  ],
};

export const haveYouSeenWalkInClinicEnum = {
  question:
    "Have you visited a walk-in clinic for Allergic Rhinitis in the past 12 months?",
  options: [
    {
      value: "no",
      label: "No",
    },
    {
      value: "lastThreeMonths",
      label: "Yes, within the last 3 Months",
    },
    {
      value: "lastSixMonths",
      label: "Yes, within the last 6 Months",
    },
    {
      value: "lastTwelveMonths",
      label: "Yes, within the last 12 Months",
    },
  ],
};

export const HistoryCardOptions = [
  {
    lable: "Nasal Irrigations, Sprays, or Lubricants",
    value: "nasalIrrigations",
    display: false,
    cardIndex: 2, // index 1 reserved for Default question, // will be used when we select card
    isMulti: true,
  },
  {
    lable: "Nasal or Oral Decongestants",
    value: "nasalOrOralDecongestants",
    display: false,
    cardIndex: 3,
    isMulti: true,
  },
  {
    lable: "Oral Antihistamines",
    value: "oralAntihistamines",
    display: false,
    cardIndex: 4,
    isMulti: false,
  },
  {
    lable: "Intranasal Corticosteroids",
    value: "intranasalCorticosteroids",
    display: false,
    cardIndex: 5,
    isMulti: false,
  },
  {
    lable: "Intranasal Antihistamine/Corticosteroid",
    value: "intranasalAntihistaminesAndCorticosteroids",
    display: false,
    cardIndex: 6,
    isMulti: false,
  },
  {
    lable: "None",
    value: "none",
    display: false,
    cardIndex: 7,
    isMulti: false,
  },
];

export const getTreatmentDrugs = (treatment) => {
  const prescriptions = [
    treatment?.firstLineTherapyPrescriptions,
    treatment?.stepUpTherapyPrescriptions,
    treatment?.alternativeFirstLineTherapyPrescriptions,
    treatment?.addOnTherapyOralDecongestantsPrescriptions,
    treatment?.addOnTherapyIntranasalDecongestantsPrescriptions,
    treatment?.addOnTherapyOralAntihistaminesPrescriptions,
    treatment?.nasalSalineRinsePrescriptions,
    treatment?.nasalSalineSprayPrescriptions,
    treatment?.nasalLubricantPrescriptions,
  ];

  let combinedDrugs = prescriptions
    .filter((list) => Array.isArray(list) && list.length > 0)
    .flat();

  if (combinedDrugs.length > 0) {
    // combinedDrugs = combinedDrugs.map((x) => ({
    //   ...x,
    // }));
    return combinedDrugs;
  }
  return [];
};
